/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymSchedulingWaitingListAliases {
  AUTOCOMPLETE_ESTABLISHMENT = 'autocomplete-establishment',
  AUTOCOMPLETE_FIELD_PHYSICIAN = 'autocomplete-field-physician',
  AUTOCOMPLETE_PROCEDURE = 'autocomplete-procedure',
  AUTOCOMPLETE_SCHEDULE_TYPE = 'autocomplete-schedule-type',
  AUTOCOMPLETE_SPECIALITY = 'autocomplete-speciality',
  AUTOCOMPLETE_URGENCY_REASON = 'autocomplete-urgency-reason',
  BUTTON_CANCEL = 'button-cancel',
  BUTTON_CONFIRM = 'button-confirm',
  CARD_AVATAR_WITH_TWO_SUBTITLES_PHYSICIAN = 'card-avatar-with-two-subtitles-physician',
  CARD_AVATAR_WITH_TWO_SUBTITLES_PROCEDURE = 'card-avatar-with-two-subtitles-procedure',
  CHECKBOX_IE_URGENT = 'checkbox-ie-urgent',
  CONTEXTUAL_BAR_WAITING_LIST = 'contextual-bar-waiting-list',
  DATE_FIELD_AVAILABLE_PERIOD = 'date-field-available-period',
  DATE_FIELD_DESIRED_DATE = 'date-field-desired-date',
  FETCH_ESTABLISHMENT = 'fetch-establishment',
  FETCH_FIELD_PHYSICIAN = 'fetch-field-physician',
  FETCH_PROCEDURE = 'fetch-procedure',
  FETCH_SPECILITY = 'fetch-specility',
  FETCH_URGENCY_REASON = 'fetch-urgency-reason',
  FIELD_AVAILABLE_PERIOD = 'field-available-period',
  FIELD_AVAILABLE_PERIOD_READONLY = 'field-available-period-readonly',
  FIELD_CONTACT_NAME = 'field-contact-name',
  FIELD_CONTACT_NUMBER = 'field-contact-number',
  FIELD_DESIRED_DATE = 'field-desired-date',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_IE_URGENT = 'field-ie-urgent',
  FIELD_NOTE = 'field-note',
  FIELD_PHYSICIAN = 'field-physician',
  FIELD_PROCEDURE = 'field-procedure',
  FIELD_SCHEDULE_TYPE = 'field-schedule-type',
  FIELD_SPECIALITY = 'field-speciality',
  FIELD_URGENCY_REASON = 'field-urgency-reason',
  FORM_WAITING_LIST = 'form-waiting-list',
  GLOBAL_ACTIONS_WAITING_LIST = 'global-actions-waiting-list',
  INPUT_AVAILABLE_PERIOD_READONLY = 'input-available-period-readonly',
  INPUT_CONTACT_NAME = 'input-contact-name',
  LAYOUT_WAITING_LIST = 'layout-waiting-list',
  MAPPER_ESTABLISHMENT = 'mapper-establishment',
  MAPPER_FIELD_PHYSICIAN = 'mapper-field-physician',
  MAPPER_PROCEDURE = 'mapper-procedure',
  MAPPER_SCHEDULE_TYPE = 'mapper-schedule-type',
  MAPPER_SPECILITY = 'mapper-specility',
  MAPPER_URGENCY_REASON = 'mapper-urgency-reason',
  PANEL_WAITING_LIST = 'panel-waiting-list',
  PHONE_NUMBER_CONTACT = 'phone-number-contact',
  TEXT_ESTABLISHMENT = 'text-establishment',
  TEXT_NOTE = 'text-note',
  TEXT_SCHEDULE_TYPE = 'text-schedule-type',
  TEXT_SPECIALITY = 'text-speciality',
  TEXT_URGENCY_REASON = 'text-urgency-reason',
}
export { PseudonymSchedulingWaitingListAliases };
